<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card>
      <card-title v-if="withSearch">
        <v-text-field
          id="add-dialog-search"
          v-model="search"
          label="Поиск..."
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          @input="expandAllPanels"
        />
      </card-title>
      <card-content :class="{ 'pt-6': !withSearch }">
        <div v-for="item in treeFiltered.items" :key="item.id">
          <v-checkbox
            v-model="selectedItems"
            :label="item.title"
            :value="item"
            hide-details
            class="mt-0"
          />
        </div>
        <v-expansion-panels v-model="expanded" multiple class="mt-4">
          <v-expansion-panel
            v-for="(treeLeave, leaveIndex) in treeFiltered.sections"
            :key="leaveIndex"
            class="kk-expansion-panel mt-0"
          >
            <v-expansion-panel-header class="kk-expansion-panel-header">
              <template v-slot:actions>
                <v-icon size="16" class="kk-expansion-panel-header__icon mr-2"
                  >$expand</v-icon
                >
              </template>
              <span class="kk-expansion-panel-header__title">{{
                treeLeave.title
              }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="item in treeLeave.items" :key="item.id">
                <v-checkbox
                  v-model="selectedItems"
                  :label="item.title"
                  :value="item"
                  hide-details
                  class="mt-0"
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </card-content>
      <card-actions>
        <v-btn
          id="add-product-btn-conrfirm"
          color="primary"
          depressed
          @click="onConfirm"
        >
          Добавить
        </v-btn>
        <v-btn
          id="add-product-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          Отменить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
export default {
  name: "AddDialog",
  model: {
    prop: "open",
    event: "change"
  },

  props: {
    open: Boolean,
    selectTree: {
      type: Object,
      required: true
    },
    alreadySelectedIds: {
      type: Array,
      default: () => []
    },
    withSearch: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      search: "",
      selectedItems: [],
      expanded: []
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    treeFiltered() {
      const result = {
        items: [],
        sections: []
      };
      const { alreadySelectedIds, search, selectedItems } = this;
      result.items = (this.selectTree.items || []).filter(
        item =>
          !alreadySelectedIds.includes(item.id) &&
          (search.length == 0 ||
            item.title.toLowerCase().includes(search.toLowerCase()) ||
            selectedItems.includes(item.id))
      );
      (this.selectTree.sections || []).forEach(section => {
        const { title } = section;
        const items = section.items.filter(
          item =>
            !alreadySelectedIds.includes(item.id) &&
            (search.length == 0 ||
              item.title.toLowerCase().includes(search.toLowerCase()) ||
              selectedItems.includes(item.id))
        );
        if (items.length > 0) {
          result.sections.push({ title, items });
        }
      });
      return result;
    }
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.resetForm();
      } else if (!newVal) {
        this.$emit("close");
      }
    }
  },

  methods: {
    async onConfirm() {
      this.$emit("apply", this.selectedItems);
      this.dialog = false;
    },
    expandAllPanels() {
      this.expanded = Array.from(
        Array((this.treeFiltered.sections || []).length).keys()
      );
    },
    resetForm() {
      this.search = "";
      this.selectedItems = [];
      this.expandAllPanels();
    }
  }
};
</script>
<style lang="scss" scoped>
.kk-expansion-panel.v-expansion-panel::before {
  box-shadow: none;
}
.kk-expansion-panel.v-expansion-panel::after {
  border: none;
}

.kk-expansion-panel-header {
  min-height: 32px;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 8px;
  ::v-deep.kk-expansion-panel-header__icon {
    order: 0;
  }
  ::v-deep.kk-expansion-panel-header__title {
    order: 1;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
  }
}
</style>
